
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/firebase';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { Chrome } from 'lucide-react';

export function GoogleSignInButton() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
      const redirectTo = searchParams.get('redirect_to') || '/itinerary';
      navigate(redirectTo);
    } catch (error) {
      console.error('Google sign-in error:', error);
      // Handle error, maybe show a toast
    }
  };

  return (
    <Button variant="outline" className="w-full" onClick={handleGoogleSignIn}>
      <Chrome className="mr-2 h-4 w-4" />
      Sign in with Google
    </Button>
  );
}
